import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { actions } from './sagaSlice';

export default connect(null, actions)(props => {

    const { token } = useParams();

    props.confirm(token);

    return null;
});
